/**
 * @todo Rework into utility functions. It's not a composable.
 **/
export function useCss() {
  const NameTopbarHeight = "--topbarHeight";

  const getPropertyValue = (name: string, scope?: HTMLElement): string => {
    if (scope === undefined) {
      scope = document.documentElement;
    }
    return getComputedStyle(scope).getPropertyValue(name).trim();
  };

  const getTopbarHeight = (): number => {
    const value = getPropertyValue(NameTopbarHeight);
    const intVal = parseInt(value);
    if (isNaN(intVal)) {
      throw new Error("Invalid topbar height value: " + value);
    }

    return intVal;
  };

  // @todo would be nice to auto-sync it with variables.scss
  const Breakpoints = {
    xxl: 1600,
    xl: 1280,
    lg: 1050,
    ls: 920,
    md: 769,
    sm: 576,
    xs: 450,
    xxs: 370,
  };

  return {
    getPropertyValue,
    getTopbarHeight,

    // Constants:
    NameTopbarHeight,
    Breakpoints,
  };
}
